import api from "../helpers/util";
import moment from "moment";
const API_URL = process.env.REACT_APP_API_URL;

// Helper function to get company_id from CompanyContext
// This will be passed as a parameter to each function
const buildUrl = (path, companyId) => {
  return companyId ? `${path}?company_id=${companyId}` : path;
};

export const fetchBeefsByDate = async (date, companyId) => {
  try {
    const formatted_date = moment(date).format("YYYY-MM-DD");
    console.log("dateeeee", formatted_date);
    const url = buildUrl(`/scheduling/beefs/date/${formatted_date}`, companyId);
    const response = await api.get(url);
    return response?.data?.result ?? "No beefs found.";
  } catch (error) {
    console.log("fetching Beefs err", error);
    throw new Error("Error fetching beefs:", error);
  }
};

export const fetchLambsByDate = async (date, companyId) => {
  try {
    const formatted_date = moment(date).format("YYYY-MM-DD");
    console.log("dateeeee lamb", formatted_date);
    const url = buildUrl(`/scheduling/lambs/date/${formatted_date}`, companyId);
    const response = await api.get(url);
    return response?.data?.result ?? "No lambs found.";
  } catch (error) {
    console.log("fetching Lambs err", error);
    throw new Error("Error fetching lambs:", error);
  }
};

export const fetchPigsByDate = async (date, companyId) => {
  try {
    const formatted_date = moment(date).format("YYYY-MM-DD");
    console.log("dateeeee pigs", formatted_date);
    const url = buildUrl(`/scheduling/pigs/date/${formatted_date}`, companyId);
    const response = await api.get(url);
    return response?.data?.result ?? "No pigs found.";
  } catch (error) {
    console.log("fetching Pigs err", error);
    throw new Error("Error fetching pigs:", error);
  }
};

// Fetch goats (Caprine) by date — BVM only, returns [] for other schemas
export const fetchGoatsByDate = async (date, companyId) => {
  try {
    const formatted_date = moment(date).format("YYYY-MM-DD");
    console.log("dateeeee goats", formatted_date);
    const url = buildUrl(`/scheduling/goats/date/${formatted_date}`, companyId);
    const response = await api.get(url);
    return response?.data?.result ?? [];
  } catch (error) {
    console.log("fetching Goats err", error);
    throw new Error("Error fetching goats:", error);
  }
};

//Fetch other species by date — BVM only, returns [] for other schemas
export const fetchOthersByDate = async (date, companyId) => {
  try {
    const formatted_date = moment(date).format("YYYY-MM-DD");
    console.log("dateeeee others", formatted_date);
    const url = buildUrl(`/scheduling/others/date/${formatted_date}`, companyId);
    const response = await api.get(url);
    return response?.data?.result ?? [];
  } catch (error) {
    console.log("fetching Others err", error);
    throw new Error("Error fetching others:", error);
  }
};

export const fetchBeefs = async (companyId) => {
  try {
    const url = buildUrl("/scheduling/beefs", companyId);
    const response = await api.get(url);
    return response?.data?.result ?? "No beefs found.";
  } catch (error) {
    console.log("fetching all Beefs err", error);
    throw new Error("Error fetching all beefs:", error);
  }
};

export const fetchLambs = async (companyId) => {
  try {
    const url = buildUrl("/scheduling/lambs", companyId);
    const response = await api.get(url);
    return response?.data?.result ?? "No lambs found.";
  } catch (error) {
    console.log("fetching all Lambs err", error);
    throw new Error("Error fetching  alllambs:", error);
  }
};

export const fetchPigs = async (companyId) => {
  try {
    const url = buildUrl("/scheduling/pigs", companyId);
    const response = await api.get(url);
    return response?.data?.result ?? "No pigs found.";
  } catch (error) {
    console.log("fetching all Pigs err", error);
    throw new Error("Error fetching all pigs:", error);
  }
};

export const fetchBeefLastBodyAndLot = async (companyId) => {
  try {
    const url = buildUrl("/scheduling/beefs/last-body-lot", companyId);
    const response = await api.get(url);
    console.log("Res body and lot", response);
    return response?.data?.result ?? "Body No and Lot No  not found.";
  } catch (error) {
    console.log("fetching Beefs last body and lot no err", error);
    throw new Error("Error fetching beefs last body no and lot no:", error);
  }
};

export const fetchLambLastBodyAndLot = async (companyId) => {
  try {
    const url = buildUrl("/scheduling/lambs/last-body-lot", companyId);
    const response = await api.get(url);
    console.log("Res body and lot", response);
    return response?.data?.result ?? "Body No and Lot No  not found.";
  } catch (error) {
    console.log("fetching Lambs last body and lot no err", error);
    throw new Error("Error fetching lambs last body no and lot no:", error);
  }
};

export const fetchPigLastBodyAndLot = async (companyId) => {
  try {
    const url = buildUrl("/scheduling/pigs/last-body-lot", companyId);
    const response = await api.get(url);
    console.log("Res body and lot", response);
    return response?.data?.result ?? "Body No and Lot No  not found.";
  } catch (error) {
    console.log("fetching Pigs last body and lot no err", error);
    throw new Error("Error fetching pigs last body no and lot no:", error);
  }
};

export const createBeefBody = async (bodyData, companyId) => {
  try {
    const url = buildUrl("/scheduling/beefs/createBody", companyId);
    const response = await api.post(url, {
      ...bodyData,
      production_date: moment(bodyData.production_date).format("YYYY-MM-DD"),
    });
    console.log("created beef bodies", response.data);
    return response.data;
  } catch (error) {
    console.log("Error creating beef body:", error);
    throw new Error("Error creating beef body:", error);
  }
};

export const createLambBody = async (bodyData, companyId) => {
  try {
    const url = buildUrl("/scheduling/lambs/createBody", companyId);
    const response = await api.post(url, {
      ...bodyData,
      production_date: moment(bodyData.production_date).format("YYYY-MM-DD"),
    });
    console.log("created lamb bodies", response.data);
    return response.data;
  } catch (error) {
    console.log("Error creating lamb body:", error);
    throw new Error("Error creating lamb body:", error);
  }
};

export const createPigBody = async (bodyData, companyId) => {
  try {
    const url = buildUrl("/scheduling/pigs/createBody", companyId);
    const response = await api.post(url, {
      ...bodyData,
      production_date: moment(bodyData.production_date).format("YYYY-MM-DD"),
    });
    console.log("created pig bodies", response.data);
    return response.data;
  } catch (error) {
    console.log("Error creating pig body:", error);
    throw new Error("Error creating pig body:", error);
  }
};

export const getBodiesCount = async (companyId) => {
  try {
    const response = await api.get("/scheduling/bodies/week/count", {
      params: { company_id: companyId },
    });
    return response?.data?.result;
  } catch (error) {
    console.error("Error fetching bodies count:", error);
    throw error;
  }
};